module.exports = "download-arrow"